import {createReducer, on} from '@ngrx/store';
import {
  ClearState,
  FetchClientsListFailure,
  FetchClientsListRequest,
  FetchClientsListSuccess,
  FetchClinicFilterFailure,
  FetchClinicFilterRequest,
  FetchClinicFilterSuccess,
  FetchClinicListFailure,
  FetchClinicListRequest,
  FetchClinicListSuccess,
  FetchClinicStatusFilterListFailure,
  FetchClinicStatusFilterListRequest,
  FetchClinicStatusFilterListSuccess,
  FetchDashboardFilterFailure,
  FetchDashboardFilterRequest,
  FetchDashboardFilterSuccess,
  FetchGroupListFilterFailure,
  FetchGroupListFilterRequest,
  FetchGroupListFilterSuccess,
  FetchGroupsListFailure,
  FetchGroupsListRequest,
  FetchGroupsListSuccess,
  FetchGroupTypeFilterFailure,
  FetchGroupTypeFilterRequest,
  FetchGroupTypeFilterSuccess,
  FetchMeasurementFilterFailure,
  FetchMeasurementFilterRequest,
  FetchMeasurementFilterSuccess,
  FetchMetricOptionListFailure,
  FetchMetricOptionListRequest,
  FetchMetricOptionListSuccess,
  FetchOrgTypeFilterListFailure,
  FetchOrgTypeFilterListRequest,
  FetchOrgTypeFilterListSuccess,
  FetchParticipantsAndCaregiversListFailure,
  FetchParticipantsAndCaregiversListRequest,
  FetchParticipantsAndCaregiversListSuccess,
  FetchParticipantsBehaviourListFailure,
  FetchParticipantsBehaviourListRequest,
  FetchParticipantsBehaviourListSuccess,
  FetchParticipantsWeightListFailure,
  FetchParticipantsWeightListRequest,
  FetchParticipantsWeightListSuccess,
  FetchStatusFilterFailure,
  FetchStatusFilterRequest,
  FetchStatusFilterSuccess,
  FetchUserStatusListFilterFailure,
  FetchUserStatusListFilterRequest,
  FetchUserStatusListFilterSuccess,
  SaveConfigId
} from './clients-list.actions';
import {Filter} from "../../../../models/filter";
import {ClinicsList} from "../../../../models/clinics-list";
import {GroupsList} from "../../../../models/groups-list";
import {
  ParticipantsAndCaregiversList
} from "../../../../models/participants-and-caregivers-list";
import {
  ParticipantsWeightList
} from "../../../../models/participants-weight-list";
import {
  ParticipantsBehaviourList
} from "../../../../models/participants-behaviour-list";
import {
  MetricOptionListModel
} from '../../../../models/metric-option-list.model';

// State for this feature (User)
export interface ClientsListState {
  clientsList: {
    loading: boolean,
    list: any[]
  };
  dashboardFilter: Filter;
  statusFilter: Filter;
  groupTypeFilter: Filter;
  clinicFilter: Filter;
  measurementFilter: Filter;
  clinicsList: ClinicsList;
  groupsList: GroupsList;
  participantsAndCaregiversList: ParticipantsAndCaregiversList;
  participantsWeightList: ParticipantsWeightList;
  participantsBehaviourList: ParticipantsBehaviourList;
  measurementInformationList: MetricOptionListModel;
  configId: number,
  orgTypeListFilter: Filter,
  clinicStatusListFilter: Filter,
  groupListFilter: Filter,
  userStatusListFilter: Filter,
}

const initialState: ClientsListState = {
  clientsList: {
    loading: false,
    list: []
  },
  dashboardFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  clinicFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  measurementFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  statusFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupTypeFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  clinicsList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupsList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  participantsAndCaregiversList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  participantsWeightList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  participantsBehaviourList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  measurementInformationList: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  configId: 1,
  orgTypeListFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  clinicStatusListFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  groupListFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
  userStatusListFilter: {
    list: [],
    total: null,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  },
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, (state) => initialState),

  // FETCH CLIENTS LIST
  on(FetchClientsListRequest, (state) => ({
    ...state,
    clientsList: {
      ...initialState.clientsList,
      loading: true,
    }
  })),
  on(FetchClientsListSuccess, (state, props) => ({
    ...state,
    clientsList: {
      loading: false,
      list: props.clientsList
    }
  })),
  on(FetchClientsListFailure, (state) => ({
    ...state,
    clientsList: {
      ...state.clientsList,
      loading: false,
    }
  })),

  // FETCH DASH BOARD FILTER
  on(FetchDashboardFilterRequest, (state) => ({
    ...state,
    dashboardFilter: {
      ...initialState.dashboardFilter,
      loading: true
    }
  })),
  on(FetchDashboardFilterSuccess, (state, props) => ({
    ...state,
    dashboardFilter: {
      ...props.dashboardFilter,
      loading: false
    }
  })),
  on(FetchDashboardFilterFailure, (state) => ({
    ...state,
    dashboardFilter: {
      ...initialState.dashboardFilter,
      loading: false
    }
  })),

  // FETCH CLINIC FILTER
  on(FetchClinicFilterRequest, (state) => ({
    ...state,
    clinicFilter: {
      ...initialState.clinicFilter,
      loading: true
    }
  })),
  on(FetchClinicFilterSuccess, (state, props) => ({
    ...state,
    clinicFilter: {
      ...props.clinicFilter,
      loading: false
    }
  })),
  on(FetchClinicFilterFailure, (state) => ({
    ...state,
    clinicFilter: {
      ...initialState.clinicFilter,
      loading: false
    }
  })),

  // FETCH STATUS FILTER
  on(FetchStatusFilterRequest, (state) => ({
    ...state,
    statusFilter: {
      ...initialState.statusFilter,
      loading: true
    }
  })),
  on(FetchStatusFilterSuccess, (state, props) => ({
    ...state,
    statusFilter: {
      ...props.statusFilter,
      loading: false
    }
  })),
  on(FetchStatusFilterFailure, (state) => ({
    ...state,
    statusFilter: {
      ...initialState.statusFilter,
      loading: false
    }
  })),

  // FETCH GROUP TYPE FILTER
  on(FetchGroupTypeFilterRequest, (state) => ({
    ...state,
    groupTypeFilter: {
      ...initialState.groupTypeFilter,
      loading: true
    }
  })),
  on(FetchGroupTypeFilterSuccess, (state, props) => ({
    ...state,
    groupTypeFilter: {
      ...props.groupTypeFilter,
      loading: false
    }
  })),
  on(FetchGroupTypeFilterFailure, (state) => ({
    ...state,
    groupTypeFilter: {
      ...initialState.groupTypeFilter,
      loading: false
    }
  })),

  // FETCH CLINIC LIST
  on(FetchClinicListRequest, (state, props) => ({
    ...state,
    clinicsList: {
      ...state.clinicsList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.clinicsList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchClinicListSuccess, (state, props) => ({
    ...state,
    clinicsList: {
      ...props.clinicsList,
      loading: false,
      list: [
        ...(props.clinicsList.pageNumber === 1 ? [
          ...props.clinicsList.list
        ] : [
          ...state.clinicsList.list,
          ...props.clinicsList.list
        ])
      ]
    }
  })),
  on(FetchClinicListFailure, (state) => ({
    ...state,
    clinicsList: {
      ...state.clinicsList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH GROUPS LIST
  on(FetchGroupsListRequest, (state, props) => ({
    ...state,
    groupsList: {
      ...state.groupsList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.groupsList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchGroupsListSuccess, (state, props) => ({
    ...state,
    groupsList: {
      ...props.groupsList,
      loading: false,
      list: [
        ...(props.groupsList.pageNumber === 1 ? [
          ...props.groupsList.list
        ] : [
          ...state.groupsList.list,
          ...props.groupsList.list
        ])
      ]
    }
  })),
  on(FetchGroupsListFailure, (state) => ({
    ...state,
    groupsList: {
      ...state.groupsList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH PARTICIPANT AND CAREGIVERS LIST
  on(FetchParticipantsAndCaregiversListRequest, (state, props) => ({
    ...state,
    participantsAndCaregiversList: {
      ...state.participantsAndCaregiversList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.participantsAndCaregiversList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchParticipantsAndCaregiversListSuccess, (state, props) => ({
    ...state,
    participantsAndCaregiversList: {
      ...props.participantsAndCaregiversList,
      loading: false,
      list: [
        ...(props.participantsAndCaregiversList.pageNumber === 1 ? [
          ...props.participantsAndCaregiversList.list
        ] : [
          ...state.participantsAndCaregiversList.list,
          ...props.participantsAndCaregiversList.list
        ])
      ]
    }
  })),
  on(FetchParticipantsAndCaregiversListFailure, (state) => ({
    ...state,
    participantsAndCaregiversList: {
      ...state.participantsAndCaregiversList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH PARTICIPANT WEIGHT LIST
  on(FetchParticipantsWeightListRequest, (state, props) => ({
    ...state,
    participantsWeightList: {
      ...state.participantsWeightList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.participantsWeightList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchParticipantsWeightListSuccess, (state, props) => ({
    ...state,
    participantsWeightList: {
      ...props.participantsWeightList,
      loading: false,
      list: [
        ...(props.participantsWeightList.pageNumber === 1 ? [
          ...props.participantsWeightList.list
        ] : [
          ...state.participantsWeightList.list,
          ...props.participantsWeightList.list
        ])
      ]
    }
  })),
  on(FetchParticipantsWeightListFailure, (state) => ({
    ...state,
    participantsWeightList: {
      ...state.participantsWeightList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH PARTICIPANT BEHAVIOUR LIST
  on(FetchParticipantsBehaviourListRequest, (state, props) => ({
    ...state,
    participantsBehaviourList: {
      ...state.participantsBehaviourList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.participantsBehaviourList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchParticipantsBehaviourListSuccess, (state, props) => ({
    ...state,
    participantsBehaviourList: {
      ...props.participantsBehaviourList,
      loading: false,
      list: [
        ...(props.participantsBehaviourList.pageNumber === 1 ? [
          ...props.participantsBehaviourList.list
        ] : [
          ...state.participantsBehaviourList.list,
          ...props.participantsBehaviourList.list
        ])
      ]
    }
  })),
  on(FetchParticipantsBehaviourListFailure, (state) => ({
    ...state,
    participantsBehaviourList: {
      ...state.participantsBehaviourList,
      loading: false
    }
  })),

  // FETCH MEASUREMENT INFORMATION LIST
  on(FetchMetricOptionListRequest, (state, props) => ({
    ...state,
    measurementInformationList: {
      ...state.measurementInformationList,
      list: [
        ...(
          props.payload?.pageNumber ?
          props.payload?.pageNumber === 1 ? [] : [...state.measurementInformationList.list] :
            []
        )
      ],
      loading: true
    }
  })),
  on(FetchMetricOptionListSuccess, (state, props) => ({
    ...state,
    measurementInformationList: {
      ...props.measurementInformationList,
      loading: false,
      list: [
        ...(props.measurementInformationList.pageNumber === 1 ? [
          ...props.measurementInformationList.list
        ] : [
          ...state.measurementInformationList.list,
          ...props.measurementInformationList.list
        ])
      ]
    }
  })),
  on(FetchMetricOptionListFailure, (state) => ({
    ...state,
    measurementInformationList: {
      ...state.measurementInformationList,
      hasNext: false,
      hasPrev: false,
      loading: false
    }
  })),

  // FETCH MEASUREMENT FILTER
  on(FetchMeasurementFilterRequest, (state) => ({
    ...state,
    measurementFilter: {
      ...initialState.measurementFilter,
      loading: true
    }
  })),
  on(FetchMeasurementFilterSuccess, (state, props) => ({
    ...state,
    measurementFilter: {
      ...props.measurementFilter,
      loading: false
    }
  })),
  on(FetchMeasurementFilterFailure, (state) => ({
    ...state,
    measurementFilter: {
      ...initialState.measurementFilter,
      loading: false
    }
  })),

  // SAVE CONFIG ID
  on(SaveConfigId, (state, props) => ({
    ...state,
    configId: props.configId
  })),

  // FETCH ORG TYPE LIST FILTER
  on(FetchOrgTypeFilterListRequest, (state) => ({
    ...state,
    orgTypeListFilter: {
      ...initialState.orgTypeListFilter,
      loading: true
    }
  })),
  on(FetchOrgTypeFilterListSuccess, (state, props) => ({
    ...state,
    orgTypeListFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchOrgTypeFilterListFailure, (state) => ({
    ...state,
    orgTypeListFilter: {
      ...initialState.orgTypeListFilter,
      loading: false
    }
  })),

  // FETCH CLINIC STATUS LIST FILTER
  on(FetchClinicStatusFilterListRequest, (state) => ({
    ...state,
    clinicStatusListFilter: {
      ...initialState.clinicStatusListFilter,
      loading: true
    }
  })),
  on(FetchClinicStatusFilterListSuccess, (state, props) => ({
    ...state,
    clinicStatusListFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchClinicStatusFilterListFailure, (state) => ({
    ...state,
    clinicStatusListFilter: {
      ...initialState.clinicStatusListFilter,
      loading: false
    }
  })),

  // FETCH GROUP LIST FILTER
  on(FetchGroupListFilterRequest, (state) => ({
    ...state,
    groupListFilter: {
      ...initialState.groupListFilter,
      loading: true
    }
  })),
  on(FetchGroupListFilterSuccess, (state, props) => ({
    ...state,
    groupListFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchGroupListFilterFailure, (state) => ({
    ...state,
    groupListFilter: {
      ...initialState.groupListFilter,
      loading: false
    }
  })),

  // FETCH USER STATUS LIST FILTER
  on(FetchUserStatusListFilterRequest, (state) => ({
    ...state,
    userStatusListFilter: {
      ...initialState.userStatusListFilter,
      loading: true
    }
  })),
  on(FetchUserStatusListFilterSuccess, (state, props) => ({
    ...state,
    userStatusListFilter: {
      ...props.data,
      loading: false
    }
  })),
  on(FetchUserStatusListFilterFailure, (state) => ({
    ...state,
    userStatusListFilter: {
      ...initialState.userStatusListFilter,
      loading: false
    }
  })),
);
